import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { CertificationEvaluationEvent } from '../models/pns-event';
import { environment } from '../../../environments/environment';
import { PageRequest, PaginatedResponse } from '../models/pageable';
import { FiltersState } from '../store/pns-filters.store';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root',
})
export class CertificationEvaluationEventService {
  private logger = inject(LoggingService);
  constructor(private http: HttpClient) {}

  public getEvents(
    request: PageRequest,
    filters: Partial<FiltersState>,
  ): Observable<PaginatedResponse<CertificationEvaluationEvent>> {
    let params = new HttpParams()
      .set('page', request.page.toString())
      .set('size', request.size.toString());

    if (request.sort && request.sort.length > 0) {
      request.sort.forEach((sortString) => {
        params = params.append('sort', sortString);
      });
    }

    this.logger.log('🚀 Dati inviati al backend:', {
      url: `${environment.baseApiUrl}/api/certifications/events/page`,
      queryParams: params.toString(),
      body: filters,
    });

    return this.http.post<PaginatedResponse<CertificationEvaluationEvent>>(
      `${environment.baseApiUrl}/api/certifications/events/page`,
      filters,
      { params },
    );
  }

  public getEventById(id: string): Observable<CertificationEvaluationEvent> {
    return this.http.get<CertificationEvaluationEvent>(
      `${environment.baseApiUrl}/api/certifications/events/${id}`,
    );
  }
}
